var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-list',[(_vm.me)?_c('mobile-progress-card',{attrs:{"user":_vm.me}}):_vm._e(),_vm._l((_vm.activeUsers),function(user){return _c('mobile-progress-card',{key:user.userId,attrs:{"user":user}})})],2)}
var staticRenderFns = []

export { render, staticRenderFns }